export function formatCurrency(value, currency = "DKK") {
  const safeCurrency = currency === "SEK" ? "SEK" : "DKK";
  const locale = safeCurrency === "SEK" ? "sv-SE" : "da-DK";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: safeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}